import style from "./ItemFormWrapper.module.css";

export const ItemFormWrapper = ({
  children,
  onBack,
  onContinue,
  isReview,
  isLastStep,
  isLoading,
}) => {
  return (
    <div className={style.wrapper}>
      <div className={style.formWrapper}>{children}</div>
      <div className={style.buttonsWrapper}>
        {onBack ? (
          <button onClick={onBack} className={style.backButton}>
            Back
          </button>
        ) : (
          <div />
        )}

        {onContinue && !(isReview && isLastStep) ? (
          <button
            onClick={onContinue}
            className={style.continueButton}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : isReview ? "Next" : "Continue"}
          </button>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};
